import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import { H6, Image } from "../../../../AbstractElements";
import { baseUrl, mediaUrl } from "../../../../Utils/FileUpload";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

type PackageType = {
  id: number;
  name: string;
  image: string;
  amount: string;
  total_bought_count: number;
};

export default function JobCardTable() {
  const [packages, setPackages] = useState<PackageType[]>([]);
  const [loading, setLoading] = useState(true);
  const [currency, setCurrency] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseUrl}package/top_bought`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setPackages(response.data.packages);
        setCurrency(response.data.currency)
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="table-responsive theme-scrollbar">
      <Table className="display">
        <thead>
          <tr className="text-center">
            <th>S.No</th>
            <th>Package Name</th>
            <th>Amount</th>
            <th>Total Bought</th>
          </tr>
        </thead>
        <tbody >
          {loading
            ? Array(3).fill(0).map((_, index) => (
                <tr key={index} className="text-center" >
                  <td><Skeleton width={20}/></td>
                  <td>
                    <div className="d-flex align-items-center" style={{ marginLeft: "25px" }}>
                      <div className="flex-shrink-0">
                        <Skeleton circle width={25} height={25} />
                      </div>
                      <div style={{ margin: "5px" }}>
                        <Skeleton width={70} />
                      </div>
                    </div>
                  </td>
                  <td><Skeleton width={60} /></td>
                  <td><Skeleton width={40} /></td>
                </tr>
              ))
            : packages.map((item, index) => (
                <tr key={item.id} className="text-center">
                  <td>{index + 1}</td>
                  <td>
                    <div className="d-flex align-items-center" style={{ marginLeft: "25px" }}>
                      <div className="flex-shrink-0">
                        <Image
                          src={`${mediaUrl}/${item.image}`}
                          alt=""
                          width={30}
                          height={30}
                        />
                      </div>
                      <div style={{ margin: "5px" }}>
                        <H6>{item.name}</H6>
                      </div>
                    </div>
                  </td>
                  <td>{currency} {item.amount}</td>
                  <td>{item.total_bought_count}</td>
                </tr>
              ))}
        </tbody>
      </Table>
    </div>
  );
}




// import React from 'react'
// import { Table } from 'reactstrap'
// import { jobCardTableData } from '../../../../Data/Dashboard/Default'
// import { H6, Image } from '../../../../AbstractElements'
// import { dynamicImage } from '../../../../Utils'

// export default function JobCardTable() {
//     return (
//         <div className="table-responsive theme-scrollbar">
//             <Table className="display">
//                 <thead>
//                     <tr>
//                         <th>{'Time '}</th>
//                         <th>{'Job '}</th>
//                         <th>{'Company'}</th>
//                         <th className="text-center">{'Employee'} </th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {jobCardTableData.map((item) => (
//                         <tr key={item.id}>
//                             <td>{item.time}</td>
//                             <td>{item.job}</td>
//                             <td>{item.company}</td>
// <td>
//     <div className="d-flex align-items-center gap-2">
//         <div className="flex-shrink-0">
//             <Image src={dynamicImage(`dashboard-1/user/${item.image}`)} alt="" />
//         </div>
//         <div className="flex-grow-1">
//             <H6>{item.employee}</H6>
//         </div>
//     </div>
// </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </Table>
//         </div>
//     )
// }
